import classNames from 'classnames';
import debounce from 'lodash/debounce';
import {
    Children, useRef, useState, forwardRef
} from 'react';
import { Button } from 'palette/Button';
import horizontalScroll from '@helpers/horizontalScroll';
import { getButtonVisibility } from '../helpers';

import '../styles/CarouselV2.scss';

const DELAY = 350;

const CarouselV2 = forwardRef(({
    children,
    title,
    headlineAction,
    showButtons = false,
    modifier = null,
    className,
    group
}, ref) => {
    const scrollAreaRef = useRef(null);
    const [buttonVisibility, setButtonVisibility] = useState({ left: false, right: true });

    const buttonClickHandler = debounce((invert = false) => {
        horizontalScroll(scrollAreaRef.current, { invert });

        setTimeout(() => {
            setButtonVisibility(getButtonVisibility(scrollAreaRef.current));
        }, DELAY);
    }, DELAY, { leading: true });

    return (
        <div
            ref={ref}
            className={classNames('carousel-v2', className, {
                [`carousel-v2--${modifier}`]: modifier
            })}
        >
            {(headlineAction || title)
            && (
                <div className="carousel-v2__headline">
                    {headlineAction
                && (
                    <div className="carousel-v2__headline__action">
                        <Button
                            label={headlineAction.label}
                            onClick={headlineAction.callback}
                        />
                    </div>
                )}
                    {title
                    && <div className="carousel-v2__headline__title title-2">{title}</div>}
                </div>
            )}
            <div
                ref={scrollAreaRef}
                className="carousel-v2__content"
            >
                {Children.map(children, child => (
                    <div
                        className="carousel-v2__content__item"
                        data-products-group={group}
                    >
                        {child}
                    </div>
                ))}
            </div>
            {
                showButtons && buttonVisibility.left
                && (
                    <Button
                        className="carousel-v2__btn carousel-v2__btn--left"
                        icon="palette_chevron_left"
                        shape="round"
                        size="large"
                        theme="secondary"
                        onClick={() => buttonClickHandler(true)}
                    />
                )
            }
            {
                showButtons && buttonVisibility.right
                && (
                    <Button
                        customClass="carousel-v2__btn carousel-v2__btn--right"
                        iconName="palette_chevron_right"
                        shape="round"
                        size="large"
                        theme="secondary"
                        onClick={() => buttonClickHandler()}
                    />
                )
            }
        </div>
    );
});

export default CarouselV2;
